export enum UiLayoutConstant {
    SPLASH_PAGE = '/',
    PRIMARY_DASHBOARD_PAGE = '/dashboard',
    ERROR_404_PAGE = '/somethingWentWrong',
    RESET_PASSWORD_PAGE = '/resetPassword',
    SIGN_UP = '/signup',
}
